
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.046 14.282A7.984 7.984 0 010 8a8 8 0 113.046 6.282zm9.193-2.036A5.981 5.981 0 018 14a5.981 5.981 0 01-4.239-1.754C4.604 10.893 6.097 10 8 10s3.396.893 4.239 2.246zM8 9a2 2 0 100-4 2 2 0 000 4z","fill":"currentColor"}})])
          )
        }
      }
    